(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.HDScenes = window.HDScenes || {};
    function c(v) { return Math.max(0, Math.min(1, v)); }
    function seg(t, a, b) { return c((t - a) / (b - a)); }
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function back(t) { var s = 1.7; t = t - 1; return t * t * ((s + 1) * t + s) + 1; }

    function setup(el) {
      var q = function (n) { return el.querySelector('[data-jr="' + n + '"]'); };
      var r = { scenes: el.querySelectorAll('.hd-jr__scene'), steps: el.querySelectorAll('.hd-jr__step'), nodes: el.querySelectorAll('.hd-jr__node'),
        day: el.querySelector('[data-jr-day]'), tap: q('tap'), buy: q('buy'), ok: q('ok'), oktext: q('oktext'), clip: q('printclip'), head: q('head'),
        mini: q('minishirt'), lidL: q('lidL'), lidR: q('lidR'), tape: q('tape'), stamp: q('stamp'), route: q('route'), parcel: q('parcel'),
        door: q('doorlight'), arrive: q('arrive'), conf: q('confetti'), done: q('done') };
      r.len = r.route.getTotalLength();
      r.route.style.strokeDasharray = r.len; r.route.style.strokeDashoffset = r.len;
      var ns = 'http://www.w3.org/2000/svg', cols = ['#2de2ff', '#ff2bd6', '#d9b45a', '#ffffff', '#9b7bff'];
      r.bits = [];
      for (var i = 0; i < 22; i++) {
        var b = document.createElementNS(ns, 'rect');
        b.setAttribute('width', 6 + (i % 3) * 2); b.setAttribute('height', 4); b.setAttribute('rx', 1);
        b.setAttribute('fill', cols[i % cols.length]);
        r.conf.appendChild(b);
        r.bits.push({ el: b, a: (i / 22) * Math.PI * 2 + (i % 2) * 0.3, d: 90 + (i * 37) % 80, s: i % 2 ? 1 : -1 });
      }
      el.__jr = r; return r;
    }

    window.HDScenes.journey = function (el, p) {
      var r = el.__jr || setup(el), n = 5, f = p * n, idx = Math.min(n - 1, Math.floor(f));
      for (var i = 0; i < n; i++) {
        var d = f - i, op;
        if (d < 0) op = i === 0 ? 1 : c(1 + d * 5);
        else if (d > 1) op = i === n - 1 ? 1 : c(1 - (d - 1) * 5);
        else op = 1;
        r.scenes[i].style.opacity = op.toFixed(3);
        r.steps[i].classList.toggle('is-active', i === idx);
        r.steps[i].classList.toggle('is-done', i < idx);
        r.nodes[i].classList.toggle('is-on', i <= idx);
      }
      if (r.day && r.steps[idx]) r.day.textContent = r.steps[idx].getAttribute('data-day');
      var s;

      /* 1 Bestellung */
      s = c(f);
      var m = ease(seg(s, 0, .4)), tx = 430 + (300 - 430) * m, ty = 400 + (281 - 400) * m;
      r.tap.setAttribute('cx', tx); r.tap.setAttribute('cy', ty);
      var press = seg(s, .4, .5) - seg(s, .5, .6);
      r.buy.setAttribute('transform', 'translate(300 281) scale(' + (1 - press * .08) + ') translate(-300 -281)');
      var okk = back(seg(s, .55, .8));
      r.ok.setAttribute('opacity', seg(s, .55, .65)); r.ok.setAttribute('transform', 'translate(300 150) scale(' + Math.max(.01, okk) + ') translate(-300 -150)');
      r.oktext.setAttribute('opacity', seg(s, .7, .85));
      r.tap.setAttribute('opacity', 1 - seg(s, .7, .8));

      /* 2 Druck */
      s = c(f - 1);
      var pr = seg(s, .05, .9);
      r.clip.setAttribute('height', (270 * pr).toFixed(1));
      var hx = 300 + Math.sin(s * Math.PI * 9) * 46, hy = 100 + 270 * pr;
      r.head.setAttribute('transform', 'translate(' + hx.toFixed(1) + ' ' + hy.toFixed(1) + ')');
      r.head.setAttribute('opacity', 1 - seg(s, .9, 1));

      /* 3 Verpackung */
      s = c(f - 2);
      var dn = ease(seg(s, 0, .45));
      r.mini.setAttribute('transform', 'translate(300 ' + (230 + dn * 110) + ') scale(' + (0.55 - dn * .2) + ') translate(-300 -230)');
      r.mini.setAttribute('opacity', 1 - seg(s, .4, .5));
      var lid = ease(seg(s, .45, .75));
      r.lidL.setAttribute('transform', 'rotate(' + (-110 + 110 * lid) + ' 205 244)');
      r.lidR.setAttribute('transform', 'rotate(' + (110 - 110 * lid) + ' 395 244)');
      r.tape.style.strokeDashoffset = 200 - 200 * seg(s, .75, .9);
      r.stamp.setAttribute('opacity', seg(s, .88, .98));

      /* 4 Versand */
      s = c(f - 3);
      var rt = ease(seg(s, 0, .95));
      r.route.style.strokeDashoffset = (r.len * (1 - rt)).toFixed(1);
      var pt = r.route.getPointAtLength(r.len * rt);
      r.parcel.setAttribute('transform', 'translate(' + pt.x.toFixed(1) + ' ' + (pt.y - 22).toFixed(1) + ')');

      /* 5 Bei dir */
      s = c(f - 4);
      var ar = ease(seg(s, 0, .45));
      r.arrive.setAttribute('transform', 'translate(' + (40 + 210 * ar).toFixed(1) + ' 360)');
      r.door.setAttribute('opacity', (seg(s, .4, .55) * .55).toFixed(3));
      var cf = seg(s, .5, 1), ce = ease(cf);
      r.bits.forEach(function (b) {
        var x = 300 + Math.cos(b.a) * b.d * ce, y = 250 + Math.sin(b.a) * b.d * ce + cf * cf * 60;
        b.el.setAttribute('transform', 'translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ') rotate(' + (cf * 540 * b.s).toFixed(0) + ')');
        b.el.setAttribute('opacity', cf > 0 ? (1 - seg(cf, .7, 1)).toFixed(2) : 0);
      });
      r.done.setAttribute('opacity', seg(s, .55, .7));
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-quality"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.HDScenes = window.HDScenes || {};
    window.HDScenes.quality = function (el, p) {
      if (!el.__q) el.__q = el.querySelectorAll('[data-q-count]');
      el.__q.forEach(function (n) {
        var t = Number(n.getAttribute('data-t')), k = Math.max(0, Math.min(1, (p - t) * 3.2));
        k = 1 - Math.pow(1 - k, 3);
        n.textContent = Math.round(Number(n.getAttribute('data-q-count')) * k);
      });
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-signoff"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(sec) {
      if (sec.__hdSo) return; sec.__hdSo = true;
      var v = sec.querySelector('video'), worded = false;
      var word = function () { if (!worded) { worded = true; sec.classList.add('is-word'); } };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) { word(); return; }
      if (v) {
        v.addEventListener('timeupdate', function () { if (v.duration && v.currentTime >= v.duration - 0.7) word(); });
        v.addEventListener('ended', word);
        v.addEventListener('error', word);
      }
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        if (v) {
          var p = v.play(); if (p && p.catch) p.catch(word);
          setTimeout(function () { if (!v.currentTime) word(); }, 1800);
        } else {
          setTimeout(word, 350);
        }
      }, { threshold: 0.45 });
      io.observe(sec);
    }
    document.querySelectorAll('[data-hd-signoff]').forEach(setup);
    document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-hd-signoff]'); if (s) setup(s); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-support"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Chat-Animation: Nachrichten erscheinen nacheinander mit Tipp-Anzeige */
    function playChat(box) {
      if (box.__played) return; box.__played = true;
      var msgs = box.querySelectorAll('.hd-sup__msg'), typing = box.querySelector('.hd-sup__typing'), i = 0;
      if (reduce) { msgs.forEach(function (m) { m.classList.add('is-shown'); }); return; }
      (function next() {
        if (i >= msgs.length) { typing.classList.remove('is-on'); return; }
        var m = msgs[i], shop = m.classList.contains('hd-sup__msg--shop');
        if (shop) { typing.classList.add('is-on'); m.parentNode.insertBefore(typing, m); }
        setTimeout(function () {
          typing.classList.remove('is-on');
          m.classList.add('is-shown'); i++;
          setTimeout(next, 650);
        }, shop ? 1200 : 450);
      })();
    }
    function initChat() {
      document.querySelectorAll('[data-hd-chat]').forEach(function (box) {
        if (!('IntersectionObserver' in window)) return playChat(box);
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { playChat(box); io.disconnect(); } }, { threshold: .45 });
        io.observe(box);
      });
    }

    /* FAQ weich auf- und zuklappen */
    function initFaq() {
      document.querySelectorAll('.hd-faq').forEach(function (d) {
        if (d.__faq) return; d.__faq = true;
        d.querySelector('summary').addEventListener('click', function (e) {
          e.preventDefault();
          if (d.open) { d.classList.remove('is-open'); setTimeout(function () { d.open = false; }, 450); }
          else { d.open = true; requestAnimationFrame(function () { d.classList.add('is-open'); }); }
        });
      });
    }

    /* Chat-Button: Shopify Inbox öffnen, sonst Kontaktseite */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-hd-chat-open]');
      if (!b) return;
      var inbox = document.querySelector('inbox-online-store-chat, #ShopifyChat');
      var btn = inbox && (inbox.shadowRoot ? inbox.shadowRoot.querySelector('button') : inbox.querySelector('button'));
      if (btn) { btn.click(); return; }
      window.location.href = '/pages/contact';
    });

    function init() { initChat(); initFaq(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
